import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import ThinFooter from "../Footer/ThinFooter";
import { Link } from "react-router-dom";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import FloorSelector from "./FloorSelector";
import { useContext, useEffect, useState, useRef } from "react";
import FloorMap from "./FloorMap";
import StoreDetails from "./StoreDetails";
import StoreCloud from "./StoreCloud";
import { AuthContext } from "../../context/auth";
import Modal from "../Atomics/Modal";
import { ExhibitionContext } from "../../context/exhibition";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { exhibitionFetcher } from "../../api/requests";
import LoadingIndicator from "../Atomics/Loading/Loading";

const Exhibition = () => {
  // const [floors, setFloors] = useState(() => {
  //   const saved = localStorage.getItem("admin_floors");
  //   return saved ? JSON.parse(saved) : exhibitionFloors;
  // });
  // const { stores } = useContext(ExhibitionContext);
  const [floors, setFloors] = useState([]);
  const [stores, setStores] = useState([]);
  const [floor, setFloor] = useState([]);
  const [floorsLoading, setFloorsLoading] = useState(false);
  const [storesLoading, setStoresLoading] = useState(false);
  const [current, setCurrent] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const [exhibition, setExhibition] = useState({});
  const [exhibitionLoading, setExhibitionLoading] = useState(false);
  const [meetingCards, setMeetingCards] = useState([]);
  const [isLoadingMeetingCards, setIsLoadingMeetingCards] = useState(false);
  const [showMeetingCards, setShowMeetingCards] = useState(false);
  const { user } = useContext(AuthContext);
  const params = useParams();
  const exhibitionId = params.id;
  const { exhibitions, isLoadingExhibitions } = useContext(ExhibitionContext);
  const previousFloorRef = useRef(null);
  const { stores: allStores } = useContext(ExhibitionContext);

  const getEachExhibition = async () => {
    setExhibitionLoading(true);
    try {
      const res = await exhibitionFetcher.getEachExhibition(exhibitionId);
      setExhibition(res);
    } catch (err) {
      console.error(err);
    } finally {
      setExhibitionLoading(false);
    }
  };

  const getExhibitionFloors = async () => {
    setFloorsLoading(true);
    try {
      const res = await exhibitionFetcher.getExhibitionFloors(exhibitionId);
      const fetchedFloors = res?.results || res || [];
      setFloors(fetchedFloors);

      const defaultCurrentId =
        (fetchedFloors[0] && fetchedFloors[0].id) || null;
      const nextCurrent = current || defaultCurrentId;
      if (nextCurrent) {
        setCurrent(nextCurrent);
        const eachFloor = await exhibitionFetcher.getExhibitionEachFloor(
          exhibitionId,
          nextCurrent
        );
        setFloor(eachFloor);
      } else {
        setFloor(null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setFloorsLoading(false);
    }
  };

  const getFloorStores = async (forceLoading = false) => {
    if (forceLoading) {
      setStoresLoading(true);
    }
    try {
      const res = await exhibitionFetcher.getFloorStores(current);
      setStores(res?.results);
    } catch (err) {
      console.error(err);
    } finally {
      if (forceLoading) {
        setStoresLoading(false);
      }
    }
  };

  const fetchMeetingCards = async () => {
    setIsLoadingMeetingCards(true);
    try {
      const meetings = await exhibitionFetcher.getMeetingCards();
      const fetchedMeetings = meetings?.results || meetings || [];
      setMeetingCards(fetchedMeetings);
    } catch (error) {
      console.error("Error fetching meeting cards:", error);
      setMeetingCards([]);
    } finally {
      setIsLoadingMeetingCards(false);
    }
  };

  useEffect(() => {
    const fetchSelectedFloor = async () => {
      if (!current) return;
      try {
        const eachFloor = await exhibitionFetcher.getExhibitionEachFloor(
          exhibitionId,
          current
        );
        setFloor(eachFloor);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSelectedFloor();
    // Only show loading spinner when floor actually changes (not on initial load or same floor selection)
    const isFloorChanging =
      previousFloorRef.current !== null && previousFloorRef.current !== current;
    getFloorStores(isFloorChanging);
    previousFloorRef.current = current;
  }, [current, exhibitionId]);

  useEffect(() => {
    const savedTheme = localStorage.getItem("exhibition_site_theme");
    if (savedTheme) {
      document.documentElement.style.setProperty("--site-theme", savedTheme);
    }
  }, []);

  // Sync theme with selected floor background color
  useEffect(() => {
    // Find the current floor object from the floors array
    const currentFloor = floors.find((floor) => floor.id === current);
    const color = currentFloor?.floor_background_color;
    if (color) {
      document.documentElement.style.setProperty("--site-theme", color);
      localStorage.setItem("exhibition_site_theme", color);
    }
  }, [current, floors]);

  useEffect(() => {
    getEachExhibition();
    getExhibitionFloors();
    fetchMeetingCards();
  }, [exhibitionId]);

  return (
    <>
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <ContentWrapper>
        <Container fluid>
          <section className="blog-page section-padding">
            <Container style={{ paddingLeft: "0px", paddingRight: "0px" }}>
              <Row>
                <div
                  style={{
                    width: "100%",
                    paddingLeft: "30px",
                    paddingRight: "30px",
                  }}
                >
                  {(user.role === "is_superuser" ||
                    user.role === "is_supervisor") && (
                    <Link
                      to="/exhibition-admin"
                      title="پنل مدیریت نمایشگاه"
                      aria-label="پنل مدیریت نمایشگاه"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 1px 5px rgba(0,0,0,.2)",
                        color: "var(--site-theme-dark)",
                        background: "var(--site-theme-dark)",
                        textDecoration: "none",
                        marginBottom: "20px",
                        marginTop: "20px",
                      }}
                    >
                      ⚙️
                    </Link>
                  )}

                  <header className="exhibition-header">
                    {exhibitionLoading ? (
                      <LoadingIndicator />
                    ) : (
                      <div
                        className="exhibition-container"
                        style={{ textAlign: "center" }}
                      >
                        <h1 className="exhibition-title">
                          {exhibition.exhibition_name}
                        </h1>
                        <p className="exhibition-subtitle">
                          {exhibition.exhibition_place} {"- "}
                          {exhibition.exhibition_year}
                        </p>
                      </div>
                    )}
                  </header>
                  <main className="exhibition-main">
                    <div
                      className="exhibition-container"
                      style={{
                        display: "grid",
                        gap: showMeetingCards ? 8 : 16,
                      }}
                    >
                      <FloorSelector 
                        floors={floors}
                        currentFloorId={current}
                        onFloorChange={(id) => {
                          setCurrent(id);
                          setSelectedStore(null);
                          setShowMeetingCards(false);
                        }}
                        onMeetingCardsClick={() => {
                          setShowMeetingCards(true);
                          setSelectedStore(null);
                          setCurrent(null);
                        }}
                        loading={floorsLoading}
                        showMeetingCards={showMeetingCards}
                        meetingCards={meetingCards}
                      />
                      <div
                        className="exhibition-floor-wrap"
                        style={{
                          padding: showMeetingCards ? "8px" : "16px",
                          height: "auto",
                          minHeight: "400px",
                        }}
                      >
                        {floorsLoading || storesLoading ? (
                          <LoadingIndicator />
                        ) : (
                          <>
                            {!showMeetingCards && (
                              <>
                                <div
                                  className="exhibition-row"
                                  style={{
                                    justifyContent: "flex-end",
                                    marginBottom: 8,
                                  }}
                                >
                                  <button
                                    className="exhibition-btn"
                                    onClick={() => setIsMapModalOpen(true)}
                                    title="نمایش تمام صفحه"
                                  >
                                    ⤢
                                  </button>
                                </div>
                                <div style={{ marginBottom: 12 }}>
                                  <h2
                                    className="exhibition-title"
                                    style={{ fontSize: 22 }}
                                  >
                                    {floor?.floor_name || floor?.floor || ""}
                                  </h2>
                                  <div className="exhibition-subtitle">
                                    کلیک روی هر غرفه برای مشاهده جزئیات
                                  </div>
                                </div>
                              </>
                            )}
                            {showMeetingCards && (
                              <div style={{ marginBottom: 10 }}>
                                <h2
                                  className="exhibition-title"
                                  style={{
                                    fontSize: 20,
                                    textAlign: "center",
                                    color: "#374151",
                                    fontWeight: "600",
                                  }}
                                >
                                  نشست های تخصصی
                                </h2>
                              </div>
                            )}
                          </>
                        )}

                        {showMeetingCards ? (
                          <div
                            className="meeting-cards-container"
                            style={{
                              background:
                                "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              borderRadius: "20px",
                              padding: "12px",
                              border: "1px solid rgba(255, 255, 255, 0.9)",
                              backdropFilter: "blur(10px)",
                              marginBottom: "10px",
                            }}
                          >
                            {isLoadingMeetingCards ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  padding: "40px",
                                  background:
                                    "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                                  borderRadius: "16px",
                                  border: "1px solid rgba(255,255,255,0.8)",
                                  boxShadow: "0 4px 5px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "18px",
                                    color: "#64748b",
                                    fontWeight: "500",
                                  }}
                                >
                                  ⏳ در حال بارگذاری جلسات...
                                </div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  gap: "12px",
                                  padding: "8px",
                                }}
                                className="meeting-cards-grid"
                              >
                                {meetingCards.map((meeting, index) => (
                                  <div
                                    key={meeting.id}
                                    className="meeting-card"
                                    style={{
                                      background:
                                        meeting.status === "Held"
                                          ? "#f9fafb"
                                          : "#ffffff",
                                      borderRadius: "20px",
                                      padding: "16px",
                                      boxShadow:
                                        meeting.status === "Held"
                                          ? "0 2px 8px rgba(0, 0, 0, 0.05)"
                                          : "0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)",
                                      border: "none",
                                      transition:
                                        "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                      position: "relative",
                                      overflow: "hidden",
                                      color:
                                        meeting.status === "Held"
                                          ? "#9ca3af"
                                          : "#374151",
                                      animation: `fadeInUp 0.6s ease-out ${
                                        index * 0.1
                                      }s both`,
                                      textAlign: "right",
                                      opacity:
                                        meeting.status === "Held" ? 0.6 : 1,
                                      cursor:
                                        meeting.status === "Held"
                                          ? "not-allowed"
                                          : "default",
                                    }}
                                    onMouseEnter={
                                      meeting.status === "Held"
                                        ? undefined
                                        : (e) => {
                                            e.currentTarget.style.transform =
                                              "translateY(-8px) scale(1.02)";
                                            e.currentTarget.style.boxShadow =
                                              "0 20px 40px rgba(0, 0, 0, 0.2), 0 4px 16px rgba(0, 0, 0, 0.12)";
                                          }
                                    }
                                    onMouseLeave={
                                      meeting.status === "Held"
                                        ? undefined
                                        : (e) => {
                                            e.currentTarget.style.transform =
                                              "translateY(0) scale(1)";
                                            e.currentTarget.style.boxShadow =
                                              "0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)";
                                          }
                                    }
                                  >
                                    <div
                                      style={{
                                        marginBottom: "12px",
                                        position: "relative",
                                        zIndex: 1,
                                      }}
                                    >
                                      <h4
                                        style={{
                                          margin: "0 0 8px 0",
                                          fontSize: "18px",
                                          fontWeight: "700",
                                          color: "#1f2937",
                                          textShadow: "none",
                                          lineHeight: "1.3",
                                        }}
                                      >
                                        {meeting.title}
                                      </h4>
                                    </div>

                                    <div
                                      style={{
                                        marginBottom: "12px",
                                        position: "relative",
                                        zIndex: 1,
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          marginBottom: "8px",
                                          backgroundColor: "#f9fafb",
                                          padding: "8px 12px",
                                          borderRadius: "12px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            filter: "none",
                                          }}
                                        >
                                          📅
                                        </span>
                                        <span
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            color: "#374151",
                                          }}
                                        >
                                          {meeting.date} / {meeting.time}
                                        </span>
                                      </div>

                                      {meeting.speakers[0].name !==
                                        "بدون سخنران" && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            marginBottom: "12px",
                                            backgroundColor: "#f9fafb",
                                            padding: "8px 12px",
                                            borderRadius: "12px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              filter: "none",
                                            }}
                                          >
                                            👥
                                          </span>
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "600",
                                              color: "#374151",
                                            }}
                                          >
                                            {meeting.speakers?.length || 0}{" "}
                                            سخنران
                                          </span>
                                        </div>
                                      )}
                                    </div>

                                    {meeting.speakers[0].name !==
                                      "بدون سخنران" &&
                                      meeting.speakers &&
                                      meeting.speakers.length > 0 && (
                                        <div
                                          style={{
                                            marginBottom: "12px",
                                            position: "relative",
                                            zIndex: 1,
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "13px",
                                              color: "#6b7280",
                                              marginBottom: "6px",
                                              fontWeight: "600",
                                              textShadow: "none",
                                            }}
                                          >
                                            سخنرانان:
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "6px",
                                            }}
                                          >
                                            {meeting.speakers.map(
                                              (speaker, index) => (
                                                <span
                                                  key={speaker.id}
                                                  style={{
                                                    background: "#f3f4f6",
                                                    padding: "6px 12px",
                                                    borderRadius: "20px",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    color: "#374151",
                                                    border: "1px solid #e5e7eb",
                                                    textShadow: "none",
                                                    transition: "all 0.2s ease",
                                                  }}
                                                >
                                                  {speaker.name}
                                                </span>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}

                                    <div
                                      style={{
                                        marginBottom: "12px",
                                        position: "relative",
                                        zIndex: 1,
                                      }}
                                    >
                                      <p
                                        style={{
                                          margin: "0 0 8px 0",
                                          fontSize: "15px",
                                          color: "#4b5563",
                                          lineHeight: "1.5",
                                          textShadow: "none",
                                          whiteSpace: "pre-line",
                                          textAlign: "",
                                        }}
                                      >
                                        {meeting.description}
                                      </p>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginTop: "12px",
                                        position: "relative",
                                        zIndex: 1,
                                      }}
                                    >
                                      <span
                                        style={{
                                          padding: "8px 16px",
                                          borderRadius: "20px",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          background:
                                            meeting.status === "Underway"
                                              ? "#dcfce7"
                                              : meeting.status === "Held"
                                              ? "#f3f4f6"
                                              : "#fef3c7",
                                          color: "#374151",
                                          textShadow: "none",
                                          boxShadow:
                                            "0 2px 8px rgba(0,0,0,0.1)",
                                          border: "1px solid #e5e7eb",
                                        }}
                                      >
                                        {meeting.status === "Underway"
                                          ? "در حال برگزاری"
                                          : meeting.status === "Held"
                                          ? "برگزار شده"
                                          : "در انتظار برگزاری"}
                                      </span>
                                      {meeting.live_broadcast_link && (
                                        <a
                                          href={
                                            meeting.status === "Held"
                                              ? "#"
                                              : meeting.live_broadcast_link
                                          }
                                          target={
                                            meeting.status === "Held"
                                              ? "_self"
                                              : "_blank"
                                          }
                                          rel="noopener noreferrer"
                                          style={{
                                            padding: "10px 20px",
                                            background:
                                              meeting.status === "Held"
                                                ? "#f3f4f6"
                                                : "#fee2e2",
                                            color:
                                              meeting.status === "Held"
                                                ? "#9ca3af"
                                                : "#374151",
                                            textDecoration: "none",
                                            borderRadius: "20px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            textShadow: "none",
                                            boxShadow:
                                              meeting.status === "Held"
                                                ? "0 2px 4px rgba(0, 0, 0, 0.05)"
                                                : "0 4px 12px rgba(0, 0, 0, 0.1)",
                                            border: "1px solid #e5e7eb",
                                            transition: "all 0.2s ease",
                                            opacity:
                                              meeting.status === "Held"
                                                ? 0.5
                                                : 1,
                                            cursor:
                                              meeting.status === "Held"
                                                ? "not-allowed"
                                                : "pointer",
                                          }}
                                          onClick={
                                            meeting.status === "Held"
                                              ? (e) => e.preventDefault()
                                              : undefined
                                          }
                                          onMouseEnter={
                                            meeting.status === "Held"
                                              ? undefined
                                              : (e) => {
                                                  e.currentTarget.style.transform =
                                                    "translateY(-2px)";
                                                  e.currentTarget.style.boxShadow =
                                                    "0 6px 16px rgba(0, 0, 0, 0.15)";
                                                }
                                          }
                                          onMouseLeave={
                                            meeting.status === "Held"
                                              ? undefined
                                              : (e) => {
                                                  e.currentTarget.style.transform =
                                                    "translateY(0)";
                                                  e.currentTarget.style.boxShadow =
                                                    "0 4px 12px rgba(0, 0, 0, 0.1)";
                                                }
                                          }
                                        >
                                          📺 پخش زنده
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <FloorMap
                            floor={floor}
                            stores={stores}
                            onStoreClick={setSelectedStore}
                            selectedStoreId={selectedStore?.id}
                          />
                        )}
                      </div>
                      {allStores?.results?.filter(
                        (item) => item.vaghfnama_channel_address
                      ).length > 0 ? (
                        <StoreCloud
                          stores={allStores?.results?.filter(
                            (item) => item.vaghfnama_channel_address
                          )}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </main>
                  <StoreDetails
                    store={selectedStore}
                    onClose={() => setSelectedStore(null)}
                  />
                </div>
              </Row>
            </Container>
          </section>
        </Container>
        <Modal isOpen={isMapModalOpen} onClose={() => setIsMapModalOpen(false)}>
          <div
            style={{
              width: "70vw",
              // height: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="exhibition-row"
              style={{
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <div
                className="exhibition-title"
                style={{ fontSize: 18, margin: 0, marginTop: "10px" }}
              >
                {floor?.floor_name || ""}
              </div>
            </div>
            <div style={{ flex: 1, minHeight: 0 }}>
              <FloorMap
                floor={floor}
                stores={stores}
                onStoreClick={setSelectedStore}
                selectedStoreId={selectedStore?.id}
              />
            </div>
          </div>
        </Modal>
        <ThinFooter />
      </ContentWrapper>
    </>
  );
};

export default Exhibition;
